export const getPage = (): number => parseInt(new URLSearchParams(window.location.search).get('page'), 10);
